/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Migrate1Inputs */

const en_wc_vs_migrate1 = /** @type {(inputs: Wc_Vs_Migrate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try WordCraft online first with a copy of a real document you work on.`)
};

/**
* | output |
* | --- |
* | "Try WordCraft online first with a copy of a real document you work on." |
*
* @param {Wc_Vs_Migrate1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_migrate1 = /** @type {((inputs?: Wc_Vs_Migrate1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Migrate1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_migrate1(inputs)
});
export { wc_vs_migrate1 as "wc.vs.migrate1" }